import { useEffect } from "react";
import styles from "./animation-pop.module.less";
import { useAnimation } from "framer-motion";
import { motion } from "polyfill/motion-polyfill/motion-polyfill";
import PropTypes from "prop-types";

const AnimationPop = (props) => {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      scale: 1,
      transition: {
        type: "spring",
        velocity: 10,
        stiffness: 700,
        damping: 80,
      },
    });
  }, [controls, props.content]);

  return (
    <motion.span animate={controls} className={[props.className, styles.container].join(" ")}>
      {props.content}
    </motion.span>
  );
};

AnimationPop.propTypes = {
  content: PropTypes.any,
};

export default AnimationPop;
